import LocationBulk from './LocationBulk';

export default LocationBulk;